export default __webpack_public_path__ + "static/media/error.67f0a710.svg";